import { render, staticRenderFns } from "./ccc-balances-to-date.vue?vue&type=template&id=572da189&scoped=true"
import script from "./ccc-balances-to-date.vue?vue&type=script&lang=js"
export * from "./ccc-balances-to-date.vue?vue&type=script&lang=js"
import style0 from "./ccc-balances-to-date.vue?vue&type=style&index=0&id=572da189&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572da189",
  null
  
)

export default component.exports